<template>
  <div class="gfooter">
    <div class="gfooter-main">
      <div class="gfooter-main__out">
        <div class="gfooter-main__in">
          <div class="gfooter-main__body">
            <div class="gfooter-main__logo">
              <div class="gfooter-main__logo-in">
                <a href="/awuxa/index.html" class="gfooter-main__logo-btn"
                  ><img src="../../assets/img/top/hero/logo.svg"
                /></a>
              </div>
            </div>

            <div class="gfooter-main__nav gfooter-nav">
              <div class="gfooter-nav__in">
                <div class="gfooter-nav__body">
                  <div class="gfooter-nav__item">
                    <a
                      href="/awuxa/lesson/index.html"
                      class="gfooter-btn"
                      :class="{ 'gfooter-btn--current': page === 'lesson' }"
                    >
                      <div class="gfooter-btn__body">
                        <div class="gfooter-btn__bg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 3430 1800"
                          >
                            <path
                              d="M3330,470H2206.73c-53.34-68.39-146.44-123-263-154.18A120.72,120.72,0,0,0,1715,278.73a120.71,120.71,0,0,0-228.74,37.1c-116.54,31.19-209.64,85.79-263,154.18H100a90.11,90.11,0,0,0-90,90V1700a90.11,90.11,0,0,0,90,90H3330a90.11,90.11,0,0,0,90-90V560A90.11,90.11,0,0,0,3330,470Z"
                            />
                          </svg>
                        </div>
                        <div class="gfooter-btn__base-clip">
                          <div
                            class="gfooter-btn__base gfooter-btn__base--lesson"
                          ></div>
                        </div>
                        <div
                          class="gfooter-btn__label gfooter-btn__label--lesson"
                        >
                          <i class="c-svg gfooter-btn__label-ico"
                            ><svg role="img">
                              <use
                                xlink:href="/awuxa/sprite.svg#gfooter_label_lesson"
                              ></use></svg
                          ></i>
                        </div>
                        <div class="gfooter-btn__arrow">
                          <i class="c-svg gfooter-btn__arrow-ico"
                            ><svg role="img">
                              <use
                                xlink:href="/awuxa/sprite.svg#arw_right"
                              ></use></svg
                          ></i>
                        </div>
                        <div
                          v-if="page !== 'lesson'"
                          class="gfooter-btn__frame"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 3430 1800"
                            class="u-hide-sp"
                          >
                            <path
                              d="M3330,470H2206.73c-85-108.95-270.86-182.92-491.73-182.92s-406.75,74-491.72,182.92H100a90.11,90.11,0,0,0-90,90V1700a90.11,90.11,0,0,0,90,90H3330a90.11,90.11,0,0,0,90-90V560A90.11,90.11,0,0,0,3330,470ZM70,560a30,30,0,0,1,30-30H862.17v-.08h393.14A208.81,208.81,0,0,1,1277,500a275.52,275.52,0,0,1,30.44-30c86.06-73.14,238.26-122.92,407.6-122.92S2036.54,396.86,2122.6,470a276,276,0,0,1,30.4,30,209.88,209.88,0,0,1,21.65,29.92H2558.8V530H3330a30,30,0,0,1,30,30h0v980a30,30,0,0,1-30,30H100a30,30,0,0,1-30-30Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1606.06"
                              cy="330.72"
                              r="104.25"
                            ></circle>
                            <path
                              d="M1606.05,451.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1606.05,451.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1606.05,242.94Z"
                            ></path>
                            <circle cx="1569.51" cy="303.14" r="56.05"></circle>
                            <path
                              d="M1569.5,371.4a68.26,68.26,0,1,1,68.26-68.26A68.26,68.26,0,0,1,1569.5,371.4Zm0-112.1a43.85,43.85,0,1,0,43.85,43.85h0A43.9,43.9,0,0,0,1569.5,259.3Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1823.94"
                              cy="330.72"
                              r="104.25"
                            ></circle>
                            <path
                              d="M1823.94,451.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1823.94,451.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1823.94,242.94Z"
                            ></path>
                            <circle cx="1787.39" cy="303.14" r="56.05"></circle>
                            <path
                              d="M1787.39,371.4a68.26,68.26,0,1,1,68.25-68.27h0A68.33,68.33,0,0,1,1787.39,371.4Zm0-112.1a43.85,43.85,0,1,0,43.84,43.86v0A43.89,43.89,0,0,0,1787.39,259.3Z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 302 247"
                            class="u-hide-tab-pc"
                          >
                            <path
                              d="M292.5,70H200.18c-8.5-10.9-27.09-18.29-49.18-18.29S110.32,59.1,101.82,70H9.5a9,9,0,0,0-9,9V237a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V79A9,9,0,0,0,292.5,70Z"
                            ></path>
                            <path
                              class="gfooter-btn-1-1"
                              d="M198.62,50c-7.46-10.71-26-18.29-47.62-18.29S110.84,39.29,103.38,50H3.5V220h295V50Z"
                            ></path>
                            <path
                              d="M292.5,47H200.18c-8.5-10.9-27.09-18.29-49.18-18.29S110.32,36.1,101.82,47H9.5a9,9,0,0,0-9,9V214a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V56A9,9,0,0,0,292.5,47Zm3,167a3,3,0,0,1-3,3H9.5a3,3,0,0,1-3-3V56a3,3,0,0,1,3-3H105a24,24,0,0,1,5.21-6c8.61-7.31,23.83-12.29,40.76-12.29s32.15,5,40.76,12.29A24,24,0,0,1,197,53H292.5a3,3,0,0,1,3,3Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="140.11"
                              cy="33.07"
                              r="10.43"
                            ></circle>
                            <path
                              d="M140.11,45.14a12.07,12.07,0,1,1,12.07-12.07A12.09,12.09,0,0,1,140.11,45.14Zm0-20.85a8.78,8.78,0,1,0,8.77,8.78A8.79,8.79,0,0,0,140.11,24.29Z"
                            ></path>
                            <path
                              d="M136.45,23.49a6.83,6.83,0,1,0,6.83,6.82A6.84,6.84,0,0,0,136.45,23.49Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="161.89"
                              cy="33.07"
                              r="10.43"
                            ></circle>
                            <path
                              d="M161.89,45.14A12.07,12.07,0,1,1,174,33.07,12.08,12.08,0,0,1,161.89,45.14Zm0-20.85a8.78,8.78,0,1,0,8.78,8.78A8.78,8.78,0,0,0,161.89,24.29Z"
                            ></path>
                            <path
                              d="M158.24,23.49a6.83,6.83,0,1,0,6.82,6.82A6.84,6.84,0,0,0,158.24,23.49Z"
                            ></path>
                          </svg>
                        </div>
                        <div
                          v-if="page === 'lesson'"
                          class="gfooter-btn__frame"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 3430 1800"
                            class="u-hide-sp"
                          >
                            <path
                              d="M3330,270H2206.73c-85-108.95-270.86-182.92-491.73-182.92s-406.75,74-491.72,182.92H100a90.11,90.11,0,0,0-90,90V1700a90.11,90.11,0,0,0,90,90H3330a90.11,90.11,0,0,0,90-90V360A90.11,90.11,0,0,0,3330,270ZM70,360a30,30,0,0,1,30-30H862.17v-.08h393.14A208.81,208.81,0,0,1,1277,300a275.52,275.52,0,0,1,30.44-30c86.06-73.14,238.26-122.92,407.6-122.92S2036.54,196.86,2122.6,270a276,276,0,0,1,30.4,30,209.88,209.88,0,0,1,21.65,29.92H2558.8V330H3330a30,30,0,0,1,30,30h0V1540a30,30,0,0,1-30,30H100a30,30,0,0,1-30-30Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1606.06"
                              cy="130.72"
                              r="104.25"
                            ></circle>
                            <path
                              d="M1606.05,251.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1606.05,251.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1606.05,42.94Z"
                            ></path>
                            <circle cx="1569.51" cy="103.14" r="56.05"></circle>
                            <path
                              d="M1569.5,171.4a68.26,68.26,0,1,1,68.26-68.26A68.26,68.26,0,0,1,1569.5,171.4Zm0-112.1a43.85,43.85,0,1,0,43.85,43.85h0A43.9,43.9,0,0,0,1569.5,59.3Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1823.94"
                              cy="130.72"
                              r="104.25"
                            ></circle>
                            <path
                              d="M1823.94,251.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1823.94,251.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1823.94,42.94Z"
                            ></path>
                            <circle cx="1787.39" cy="103.14" r="56.05"></circle>
                            <path
                              d="M1787.39,171.4a68.26,68.26,0,1,1,68.25-68.27h0A68.33,68.33,0,0,1,1787.39,171.4Zm0-112.1a43.85,43.85,0,1,0,43.84,43.86v0A43.89,43.89,0,0,0,1787.39,59.3Z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 302 247"
                            class="u-hide-tab-pc"
                          >
                            <path
                              d="M292.5,50H200.18c-8.5-10.9-27.09-18.29-49.18-18.29S110.32,39.1,101.82,50H9.5a9,9,0,0,0-9,9V237a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V59A9,9,0,0,0,292.5,50Z"
                            ></path>
                            <path
                              class="gfooter-btn-1-1"
                              d="M198.62,30c-7.46-10.71-26-18.29-47.62-18.29S110.84,19.29,103.38,30H3.5V220h295V30Z"
                            ></path>
                            <path
                              d="M292.5,27H200.18C191.68,16.1,173.09,8.71,151,8.71S110.32,16.1,101.82,27H9.5a9,9,0,0,0-9,9V214a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V36A9,9,0,0,0,292.5,27Zm3,187a3,3,0,0,1-3,3H9.5a3,3,0,0,1-3-3V36a3,3,0,0,1,3-3H105a24,24,0,0,1,5.21-6c8.61-7.31,23.83-12.29,40.76-12.29s32.15,5,40.76,12.29A24,24,0,0,1,197,33H292.5a3,3,0,0,1,3,3Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="140.11"
                              cy="13.07"
                              r="10.43"
                            ></circle>
                            <path
                              d="M140.11,25.14a12.07,12.07,0,1,1,12.07-12.07A12.09,12.09,0,0,1,140.11,25.14Zm0-20.85a8.78,8.78,0,1,0,8.77,8.78A8.79,8.79,0,0,0,140.11,4.29Z"
                            ></path>
                            <path
                              d="M136.45,3.49a6.83,6.83,0,1,0,6.83,6.82A6.84,6.84,0,0,0,136.45,3.49Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="161.89"
                              cy="13.07"
                              r="10.43"
                            ></circle>
                            <path
                              d="M161.89,25.14A12.07,12.07,0,1,1,174,13.07,12.08,12.08,0,0,1,161.89,25.14Zm0-20.85a8.78,8.78,0,1,0,8.78,8.78A8.78,8.78,0,0,0,161.89,4.29Z"
                            ></path>
                            <path
                              d="M158.24,3.49a6.83,6.83,0,1,0,6.82,6.82A6.84,6.84,0,0,0,158.24,3.49Z"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="gfooter-nav__item">
                    <a
                      href="/awuxa/free-programming/index.html"
                      class="gfooter-btn"
                      :class="{
                        'gfooter-btn--current': page === 'free-programming'
                      }"
                    >
                      <div class="gfooter-btn__body">
                        <div class="gfooter-btn__bg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 3430 1800"
                          >
                            <path
                              d="M3330,470H2206.73c-53.34-68.39-146.44-123-263-154.18A120.72,120.72,0,0,0,1715,278.73a120.71,120.71,0,0,0-228.74,37.1c-116.54,31.19-209.64,85.79-263,154.18H100a90.11,90.11,0,0,0-90,90V1700a90.11,90.11,0,0,0,90,90H3330a90.11,90.11,0,0,0,90-90V560A90.11,90.11,0,0,0,3330,470Z"
                            />
                          </svg>
                        </div>
                        <div class="gfooter-btn__base-clip">
                          <div
                            class="gfooter-btn__base gfooter-btn__base--free"
                          ></div>
                        </div>
                        <div
                          class="gfooter-btn__label gfooter-btn__label--free"
                        >
                          <i class="c-svg gfooter-btn__label-ico"
                            ><svg role="img">
                              <use
                                xlink:href="/awuxa/sprite.svg#gfooter_label_free"
                              ></use></svg
                          ></i>
                        </div>
                        <div class="gfooter-btn__arrow">
                          <i class="c-svg gfooter-btn__arrow-ico"
                            ><svg role="img">
                              <use
                                xlink:href="/awuxa/sprite.svg#arw_right"
                              ></use></svg
                          ></i>
                        </div>
                        <div
                          v-if="page !== 'free-programming'"
                          class="gfooter-btn__frame"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 3430 1800"
                            class="u-hide-sp"
                          >
                            <path
                              d="M3330,470H2206.73c-85-108.95-270.86-182.92-491.73-182.92s-406.75,74-491.72,182.92H100a90.11,90.11,0,0,0-90,90V1700a90.11,90.11,0,0,0,90,90H3330a90.11,90.11,0,0,0,90-90V560A90.11,90.11,0,0,0,3330,470ZM70,560a30,30,0,0,1,30-30H862.17v-.08h393.14A208.81,208.81,0,0,1,1277,500a275.52,275.52,0,0,1,30.44-30c86.06-73.14,238.26-122.92,407.6-122.92S2036.54,396.86,2122.6,470a276,276,0,0,1,30.4,30,209.88,209.88,0,0,1,21.65,29.92H2558.8V530H3330a30,30,0,0,1,30,30h0v980a30,30,0,0,1-30,30H100a30,30,0,0,1-30-30Z"
                            />
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1606.06"
                              cy="330.72"
                              r="104.25"
                            />
                            <path
                              d="M1606.05,451.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1606.05,451.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1606.05,242.94Z"
                            />
                            <circle cx="1569.51" cy="303.14" r="56.05" />
                            <path
                              d="M1569.5,371.4a68.26,68.26,0,1,1,68.26-68.26A68.26,68.26,0,0,1,1569.5,371.4Zm0-112.1a43.85,43.85,0,1,0,43.85,43.85h0A43.9,43.9,0,0,0,1569.5,259.3Z"
                            />
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1823.94"
                              cy="330.72"
                              r="104.25"
                            />
                            <path
                              d="M1823.94,451.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1823.94,451.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1823.94,242.94Z"
                            />
                            <circle cx="1787.39" cy="303.14" r="56.05" />
                            <path
                              d="M1787.39,371.4a68.26,68.26,0,1,1,68.25-68.27h0A68.33,68.33,0,0,1,1787.39,371.4Zm0-112.1a43.85,43.85,0,1,0,43.84,43.86v0A43.89,43.89,0,0,0,1787.39,259.3Z"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 302 247"
                            class="u-hide-tab-pc"
                          >
                            <path
                              d="M292.5,70H200.18c-8.5-10.9-27.09-18.29-49.18-18.29S110.32,59.1,101.82,70H9.5a9,9,0,0,0-9,9V237a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V79A9,9,0,0,0,292.5,70Z"
                            />
                            <path
                              class="gfooter-btn-2-1"
                              d="M198.62,50c-7.46-10.71-26-18.29-47.62-18.29S110.84,39.29,103.38,50H3.5V220h295V50Z"
                            />
                            <path
                              d="M292.5,47H200.18c-8.5-10.9-27.09-18.29-49.18-18.29S110.32,36.1,101.82,47H9.5a9,9,0,0,0-9,9V214a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V56A9,9,0,0,0,292.5,47Zm3,167a3,3,0,0,1-3,3H9.5a3,3,0,0,1-3-3V56a3,3,0,0,1,3-3H105a24,24,0,0,1,5.21-6c8.61-7.31,23.83-12.29,40.76-12.29s32.15,5,40.76,12.29A24,24,0,0,1,197,53H292.5a3,3,0,0,1,3,3Z"
                            />
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="140.11"
                              cy="33.07"
                              r="10.43"
                            />
                            <path
                              d="M140.11,45.14a12.07,12.07,0,1,1,12.07-12.07A12.09,12.09,0,0,1,140.11,45.14Zm0-20.85a8.78,8.78,0,1,0,8.77,8.78A8.79,8.79,0,0,0,140.11,24.29Z"
                            />
                            <path
                              d="M136.45,23.49a6.83,6.83,0,1,0,6.83,6.82A6.84,6.84,0,0,0,136.45,23.49Z"
                            />
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="161.89"
                              cy="33.07"
                              r="10.43"
                            />
                            <path
                              d="M161.89,45.14A12.07,12.07,0,1,1,174,33.07,12.08,12.08,0,0,1,161.89,45.14Zm0-20.85a8.78,8.78,0,1,0,8.78,8.78A8.78,8.78,0,0,0,161.89,24.29Z"
                            />
                            <path
                              d="M158.24,23.49a6.83,6.83,0,1,0,6.82,6.82A6.84,6.84,0,0,0,158.24,23.49Z"
                            />
                          </svg>
                        </div>
                        <div
                          v-if="page === 'free-programming'"
                          class="gfooter-btn__frame"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 3430 1800"
                            class="u-hide-sp"
                          >
                            <path
                              d="M3330,270H2206.73c-85-108.95-270.86-182.92-491.73-182.92s-406.75,74-491.72,182.92H100a90.11,90.11,0,0,0-90,90V1700a90.11,90.11,0,0,0,90,90H3330a90.11,90.11,0,0,0,90-90V360A90.11,90.11,0,0,0,3330,270ZM70,360a30,30,0,0,1,30-30H862.17v-.08h393.14A208.81,208.81,0,0,1,1277,300a275.52,275.52,0,0,1,30.44-30c86.06-73.14,238.26-122.92,407.6-122.92S2036.54,196.86,2122.6,270a276,276,0,0,1,30.4,30,209.88,209.88,0,0,1,21.65,29.92H2558.8V330H3330a30,30,0,0,1,30,30h0V1540a30,30,0,0,1-30,30H100a30,30,0,0,1-30-30Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1606.06"
                              cy="130.72"
                              r="104.25"
                            ></circle>
                            <path
                              d="M1606.05,251.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1606.05,251.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1606.05,42.94Z"
                            ></path>
                            <circle cx="1569.51" cy="103.14" r="56.05"></circle>
                            <path
                              d="M1569.5,171.4a68.26,68.26,0,1,1,68.26-68.26A68.26,68.26,0,0,1,1569.5,171.4Zm0-112.1a43.85,43.85,0,1,0,43.85,43.85h0A43.9,43.9,0,0,0,1569.5,59.3Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1823.94"
                              cy="130.72"
                              r="104.25"
                            ></circle>
                            <path
                              d="M1823.94,251.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1823.94,251.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1823.94,42.94Z"
                            ></path>
                            <circle cx="1787.39" cy="103.14" r="56.05"></circle>
                            <path
                              d="M1787.39,171.4a68.26,68.26,0,1,1,68.25-68.27h0A68.33,68.33,0,0,1,1787.39,171.4Zm0-112.1a43.85,43.85,0,1,0,43.84,43.86v0A43.89,43.89,0,0,0,1787.39,59.3Z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 302 247"
                            class="u-hide-tab-pc"
                          >
                            <path
                              d="M292.5,50H200.18c-8.5-10.9-27.09-18.29-49.18-18.29S110.32,39.1,101.82,50H9.5a9,9,0,0,0-9,9V237a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V59A9,9,0,0,0,292.5,50Z"
                            ></path>
                            <path
                              class="gfooter-btn-2-1"
                              d="M198.62,30c-7.46-10.71-26-18.29-47.62-18.29S110.84,19.29,103.38,30H3.5V220h295V30Z"
                            ></path>
                            <path
                              d="M292.5,27H200.18C191.68,16.1,173.09,8.71,151,8.71S110.32,16.1,101.82,27H9.5a9,9,0,0,0-9,9V214a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V36A9,9,0,0,0,292.5,27Zm3,187a3,3,0,0,1-3,3H9.5a3,3,0,0,1-3-3V36a3,3,0,0,1,3-3H105a24,24,0,0,1,5.21-6c8.61-7.31,23.83-12.29,40.76-12.29s32.15,5,40.76,12.29A24,24,0,0,1,197,33H292.5a3,3,0,0,1,3,3Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="140.11"
                              cy="13.07"
                              r="10.43"
                            ></circle>
                            <path
                              d="M140.11,25.14a12.07,12.07,0,1,1,12.07-12.07A12.09,12.09,0,0,1,140.11,25.14Zm0-20.85a8.78,8.78,0,1,0,8.77,8.78A8.79,8.79,0,0,0,140.11,4.29Z"
                            ></path>
                            <path
                              d="M136.45,3.49a6.83,6.83,0,1,0,6.83,6.82A6.84,6.84,0,0,0,136.45,3.49Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="161.89"
                              cy="13.07"
                              r="10.43"
                            ></circle>
                            <path
                              d="M161.89,25.14A12.07,12.07,0,1,1,174,13.07,12.08,12.08,0,0,1,161.89,25.14Zm0-20.85a8.78,8.78,0,1,0,8.78,8.78A8.78,8.78,0,0,0,161.89,4.29Z"
                            ></path>
                            <path
                              d="M158.24,3.49a6.83,6.83,0,1,0,6.82,6.82A6.84,6.84,0,0,0,158.24,3.49Z"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="gfooter-nav__item">
                    <a
                      href="/awuxa/movie/index.html"
                      class="gfooter-btn"
                      :class="{ 'gfooter-btn--current': page === 'movie' }"
                    >
                      <div class="gfooter-btn__body">
                        <div class="gfooter-btn__bg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 3430 1800"
                          >
                            <path
                              d="M3330,470H2206.73c-53.34-68.39-146.44-123-263-154.18A120.72,120.72,0,0,0,1715,278.73a120.71,120.71,0,0,0-228.74,37.1c-116.54,31.19-209.64,85.79-263,154.18H100a90.11,90.11,0,0,0-90,90V1700a90.11,90.11,0,0,0,90,90H3330a90.11,90.11,0,0,0,90-90V560A90.11,90.11,0,0,0,3330,470Z"
                            />
                          </svg>
                        </div>
                        <div class="gfooter-btn__base-clip">
                          <div
                            class="gfooter-btn__base gfooter-btn__base--movie"
                          ></div>
                        </div>
                        <div
                          class="gfooter-btn__label gfooter-btn__label--movie"
                        >
                          <i class="c-svg gfooter-btn__label-ico"
                            ><svg role="img">
                              <use
                                xlink:href="/awuxa/sprite.svg#gfooter_label_movie"
                              ></use></svg
                          ></i>
                        </div>
                        <div class="gfooter-btn__arrow">
                          <i class="c-svg gfooter-btn__arrow-ico"
                            ><svg role="img">
                              <use
                                xlink:href="/awuxa/sprite.svg#arw_right"
                              ></use></svg
                          ></i>
                        </div>
                        <div v-if="page !== 'movie'" class="gfooter-btn__frame">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 3430 1800"
                            class="u-hide-sp"
                          >
                            <path
                              d="M3330,470H2206.73c-85-108.95-270.86-182.92-491.73-182.92s-406.75,74-491.72,182.92H100a90.11,90.11,0,0,0-90,90V1700a90.11,90.11,0,0,0,90,90H3330a90.11,90.11,0,0,0,90-90V560A90.11,90.11,0,0,0,3330,470ZM70,560a30,30,0,0,1,30-30H862.17v-.08h393.14A208.81,208.81,0,0,1,1277,500a275.52,275.52,0,0,1,30.44-30c86.06-73.14,238.26-122.92,407.6-122.92S2036.54,396.86,2122.6,470a276,276,0,0,1,30.4,30,209.88,209.88,0,0,1,21.65,29.92H2558.8V530H3330a30,30,0,0,1,30,30h0v980a30,30,0,0,1-30,30H100a30,30,0,0,1-30-30Z"
                            />
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1606.06"
                              cy="330.72"
                              r="104.25"
                            />
                            <path
                              d="M1606.05,451.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1606.05,451.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1606.05,242.94Z"
                            />
                            <circle cx="1569.51" cy="303.14" r="56.05" />
                            <path
                              d="M1569.5,371.4a68.26,68.26,0,1,1,68.26-68.26A68.26,68.26,0,0,1,1569.5,371.4Zm0-112.1a43.85,43.85,0,1,0,43.85,43.85h0A43.9,43.9,0,0,0,1569.5,259.3Z"
                            />
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1823.94"
                              cy="330.72"
                              r="104.25"
                            />
                            <path
                              d="M1823.94,451.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1823.94,451.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1823.94,242.94Z"
                            />
                            <circle cx="1787.39" cy="303.14" r="56.05" />
                            <path
                              d="M1787.39,371.4a68.26,68.26,0,1,1,68.25-68.27h0A68.33,68.33,0,0,1,1787.39,371.4Zm0-112.1a43.85,43.85,0,1,0,43.84,43.86v0A43.89,43.89,0,0,0,1787.39,259.3Z"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 302 247"
                            class="u-hide-tab-pc"
                          >
                            <path
                              d="M292.5,70H200.18c-8.5-10.9-27.09-18.29-49.18-18.29S110.32,59.1,101.82,70H9.5a9,9,0,0,0-9,9V237a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V79A9,9,0,0,0,292.5,70Z"
                            />
                            <path
                              class="gfooter-btn-3-1"
                              d="M198.62,50c-7.46-10.71-26-18.29-47.62-18.29S110.84,39.29,103.38,50H3.5V220h295V50Z"
                            />
                            <path
                              d="M292.5,47H200.18c-8.5-10.9-27.09-18.29-49.18-18.29S110.32,36.1,101.82,47H9.5a9,9,0,0,0-9,9V214a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V56A9,9,0,0,0,292.5,47Zm3,167a3,3,0,0,1-3,3H9.5a3,3,0,0,1-3-3V56a3,3,0,0,1,3-3H105a24,24,0,0,1,5.21-6c8.61-7.31,23.83-12.29,40.76-12.29s32.15,5,40.76,12.29A24,24,0,0,1,197,53H292.5a3,3,0,0,1,3,3Z"
                            />
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="140.11"
                              cy="33.07"
                              r="10.43"
                            />
                            <path
                              d="M140.11,45.14a12.07,12.07,0,1,1,12.07-12.07A12.09,12.09,0,0,1,140.11,45.14Zm0-20.85a8.78,8.78,0,1,0,8.77,8.78A8.79,8.79,0,0,0,140.11,24.29Z"
                            />
                            <path
                              d="M136.45,23.49a6.83,6.83,0,1,0,6.83,6.82A6.84,6.84,0,0,0,136.45,23.49Z"
                            />
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="161.89"
                              cy="33.07"
                              r="10.43"
                            />
                            <path
                              d="M161.89,45.14A12.07,12.07,0,1,1,174,33.07,12.08,12.08,0,0,1,161.89,45.14Zm0-20.85a8.78,8.78,0,1,0,8.78,8.78A8.78,8.78,0,0,0,161.89,24.29Z"
                            />
                            <path
                              d="M158.24,23.49a6.83,6.83,0,1,0,6.82,6.82A6.84,6.84,0,0,0,158.24,23.49Z"
                            />
                          </svg>
                        </div>
                        <div v-if="page === 'movie'" class="gfooter-btn__frame">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 3430 1800"
                            class="u-hide-sp"
                          >
                            <path
                              d="M3330,270H2206.73c-85-108.95-270.86-182.92-491.73-182.92s-406.75,74-491.72,182.92H100a90.11,90.11,0,0,0-90,90V1700a90.11,90.11,0,0,0,90,90H3330a90.11,90.11,0,0,0,90-90V360A90.11,90.11,0,0,0,3330,270ZM70,360a30,30,0,0,1,30-30H862.17v-.08h393.14A208.81,208.81,0,0,1,1277,300a275.52,275.52,0,0,1,30.44-30c86.06-73.14,238.26-122.92,407.6-122.92S2036.54,196.86,2122.6,270a276,276,0,0,1,30.4,30,209.88,209.88,0,0,1,21.65,29.92H2558.8V330H3330a30,30,0,0,1,30,30h0V1540a30,30,0,0,1-30,30H100a30,30,0,0,1-30-30Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1606.06"
                              cy="130.72"
                              r="104.25"
                            ></circle>
                            <path
                              d="M1606.05,251.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1606.05,251.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1606.05,42.94Z"
                            ></path>
                            <circle cx="1569.51" cy="103.14" r="56.05"></circle>
                            <path
                              d="M1569.5,171.4a68.26,68.26,0,1,1,68.26-68.26A68.26,68.26,0,0,1,1569.5,171.4Zm0-112.1a43.85,43.85,0,1,0,43.85,43.85h0A43.9,43.9,0,0,0,1569.5,59.3Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="1823.94"
                              cy="130.72"
                              r="104.25"
                            ></circle>
                            <path
                              d="M1823.94,251.45a120.73,120.73,0,1,1,120.73-120.73h0A120.87,120.87,0,0,1,1823.94,251.45Zm0-208.51a87.78,87.78,0,1,0,87.78,87.79A87.78,87.78,0,0,0,1823.94,42.94Z"
                            ></path>
                            <circle cx="1787.39" cy="103.14" r="56.05"></circle>
                            <path
                              d="M1787.39,171.4a68.26,68.26,0,1,1,68.25-68.27h0A68.33,68.33,0,0,1,1787.39,171.4Zm0-112.1a43.85,43.85,0,1,0,43.84,43.86v0A43.89,43.89,0,0,0,1787.39,59.3Z"
                            ></path>
                          </svg>

                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 302 247"
                            class="u-hide-tab-pc"
                          >
                            <path
                              d="M292.5,50H200.18c-8.5-10.9-27.09-18.29-49.18-18.29S110.32,39.1,101.82,50H9.5a9,9,0,0,0-9,9V237a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V59A9,9,0,0,0,292.5,50Z"
                            ></path>
                            <path
                              class="gfooter-btn-3-1"
                              d="M198.62,30c-7.46-10.71-26-18.29-47.62-18.29S110.84,19.29,103.38,30H3.5V220h295V30Z"
                            ></path>
                            <path
                              d="M292.5,27H200.18C191.68,16.1,173.09,8.71,151,8.71S110.32,16.1,101.82,27H9.5a9,9,0,0,0-9,9V214a9,9,0,0,0,9,9h283a9,9,0,0,0,9-9V36A9,9,0,0,0,292.5,27Zm3,187a3,3,0,0,1-3,3H9.5a3,3,0,0,1-3-3V36a3,3,0,0,1,3-3H105a24,24,0,0,1,5.21-6c8.61-7.31,23.83-12.29,40.76-12.29s32.15,5,40.76,12.29A24,24,0,0,1,197,33H292.5a3,3,0,0,1,3,3Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="140.11"
                              cy="13.07"
                              r="10.43"
                            ></circle>
                            <path
                              d="M140.11,25.14a12.07,12.07,0,1,1,12.07-12.07A12.09,12.09,0,0,1,140.11,25.14Zm0-20.85a8.78,8.78,0,1,0,8.77,8.78A8.79,8.79,0,0,0,140.11,4.29Z"
                            ></path>
                            <path
                              d="M136.45,3.49a6.83,6.83,0,1,0,6.83,6.82A6.84,6.84,0,0,0,136.45,3.49Z"
                            ></path>
                            <circle
                              class="gfooter-btn__frame-fill"
                              cx="161.89"
                              cy="13.07"
                              r="10.43"
                            ></circle>
                            <path
                              d="M161.89,25.14A12.07,12.07,0,1,1,174,13.07,12.08,12.08,0,0,1,161.89,25.14Zm0-20.85a8.78,8.78,0,1,0,8.78,8.78A8.78,8.78,0,0,0,161.89,4.29Z"
                            ></path>
                            <path
                              d="M158.24,3.49a6.83,6.83,0,1,0,6.82,6.82A6.84,6.84,0,0,0,158.24,3.49Z"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 'normal'
    };
  },
  created() {
    // 不同页面的处理
    const pageMap = [
      { url: 'movie/index.html', page: 'movie' },
      { url: 'lesson/index.html', page: 'lesson' },
      { url: 'free-programming/index.html', page: 'free-programming' }
    ];
    const url = location.href;
    pageMap.forEach((p) => {
      if (url.indexOf(p.url) !== -1) {
        this.page = p.page;
      }
    });
  }
};
</script>

<style></style>
